module.exports = __webpack_public_path__ + "static/media/recruit_780_default0.bfd5093a.png";